import Character from "../../src/shell/Character";
import { InstaProfilesSlice } from "../../src/store/slices/instaSlice";
import { store } from "../../src/store/store";
import { alex } from "../characters/Alex";
import { ann } from "../characters/Ann";
import { alexInstaPhotos } from "./alexInstaHelpers";
import { annInstaPhotos } from "./annInstaHelpers";
import { random } from "./helpers";


export function getInstaData(): InstaProfilesSlice {
    const sceneName = store?.getState().gameObject.present.currentScene;
    let profiles: InstaProfilesSlice = {};
    if (ann?.properties?.hasInsta) {
        profiles = { ...profiles, [ann.key]: annInstaPhotos() };
    }

    profiles = { ...profiles, [alex.key]: alexInstaPhotos() };

    return { ...profiles };
}
